// global-polyfill.js
window.global ||= window;